import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HallOfFames } from '../hall-of-fame';

@Component({
    selector: 'app-edit-hall-of-fame',
    templateUrl: './edit-hall-of-fame.component.html',
    styleUrls: ['./edit-hall-of-fame.component.scss'],
})
export class EditHallOfFameMemberDialogComponent implements OnInit {
    title = 'Hall of Fame Editor';
    hallOfFame: HallOfFames;
    hallOfFameEditorForm: FormGroup;

    // Getters for form validation error messages
    get First(): AbstractControl {
        return this.hallOfFameEditorForm.controls.First;
    }
    get Last(): AbstractControl {
        return this.hallOfFameEditorForm.controls.Last;
    }
    get Inducted(): AbstractControl {
        return this.hallOfFameEditorForm.controls.Inducted;
    }
    get Status(): AbstractControl {
        return this.hallOfFameEditorForm.controls.Status;
    }
    get School(): AbstractControl {
        return this.hallOfFameEditorForm.controls.School;
    }

    constructor(
        private dialogRef: MatDialogRef<EditHallOfFameMemberDialogComponent>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.hallOfFame = data.hallOfFame;
        this.title = this.data.title;
    }

    ngOnInit(): void {
        this.hallOfFameEditorForm = this.formBuilder.group({
            Prefix: [this.hallOfFame.prefix],
            First: [this.hallOfFame.firstName, [Validators.required]],
            Middle: [this.hallOfFame.middleName],
            Nickname: [this.hallOfFame.nickname],
            Last: [this.hallOfFame.lastName, [Validators.required]],
            Suffix: [this.hallOfFame.suffix],
            Title: [this.hallOfFame.title],
            Inducted: [this.hallOfFame.inducted, [Validators.required]],
            Status: [this.hallOfFame.status, [Validators.required]],
            School: [this.hallOfFame.school, [Validators.required]],
            Year: [this.hallOfFame.year],
            Bio: [this.hallOfFame.bio],
            PhotoUrl: [this.hallOfFame.photoUrl],
        });
    }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

    onSubmit(formValues): void {
        this.hallOfFameEditorForm.markAllAsTouched();

        if (this.hallOfFameEditorForm.valid) {
            this.hallOfFame.prefix = formValues.Prefix;
            this.hallOfFame.firstName = formValues.First;
            this.hallOfFame.middleName = formValues.Middle;
            this.hallOfFame.nickname = formValues.Nickname;
            this.hallOfFame.lastName = formValues.Last;
            this.hallOfFame.suffix = formValues.Suffix;
            this.hallOfFame.title = formValues.Title;
            this.hallOfFame.inducted = formValues.Inducted;
            this.hallOfFame.status = formValues.Status;
            this.hallOfFame.school = formValues.School;
            this.hallOfFame.year = formValues.Year;
            this.hallOfFame.bio = formValues.Bio;
            this.hallOfFame.photoUrl = formValues.PhotoUrl;

            this.dialogRef.close(this.hallOfFame);
            this.hallOfFameEditorForm.reset();
        }
    }
}
